"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImLocalizationService = void 0;
var im_localization_service_1 = require("./services/im-localization-service");
Object.defineProperty(exports, "ImLocalizationService", { enumerable: true, get: function () { return im_localization_service_1.ImLocalizationService; } });
